import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../shared/services/language/language.service';
import { StorageService } from '../../shared/services/storage/storage.service';

/**
 * Factory function para inicializar el idioma desde localStorage
 * antes de que la aplicación arranque
 */
export function initializeLanguage(
  translateService: TranslateService,
  languageService: LanguageService,
  storageService: StorageService
) {
  return async () => {
    try {
      // Asegurarse de que Storage esté inicializado
      await storageService.init();
      
      // Obtener el idioma guardado en localStorage
      const savedLanguage = await languageService.getLanguage();
      
      // Establecer el idioma en TranslateService
      translateService.setDefaultLang(savedLanguage);
      translateService.use(savedLanguage);
      
      console.log('Language initialized:', savedLanguage);
    } catch (error) {
      // Si hay error, usar español por defecto
      console.warn('Error initializing language, using default (es):', error);
      translateService.setDefaultLang('es');
      translateService.use('es');
    }
  };
}
